import "./backdrop.css";

const Backdrop = () => {
  return <div className="back-cont"></div>;
};

export default Backdrop;
